module.exports = __webpack_public_path__ + "static/img/bottom-ac.c47bbbc1.png";